module.exports = __webpack_public_path__ + "static/media/magazine_learning.14179a2b.png";